/*=========================================================================================
  File Name: i18n.js
  Description: i18n configuration file. Imports i18n data.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { en, es, ptBR as br } from '../locales'
import { getApplicationLocalStorageItem } from '../helpers'

Vue.use(VueI18n)

const VALID_LOCALES = ['pt', 'en', 'es']
const savedLocale = getApplicationLocalStorageItem('locale')
const initialLocale = (savedLocale && VALID_LOCALES.includes(savedLocale)) ? savedLocale : 'pt'

export default new VueI18n({
  locale: initialLocale,
  messages: {
    ...br,
    ...en,
    ...es
  }
})
